import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "flex h-full min-h-[360px] flex-col rounded-lg border border-slate-200 bg-white lg:min-h-[640px]"
};
const _hoisted_2 = {
  class: "border-b border-slate-200 px-4 py-4"
};
const _hoisted_3 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_4 = {
  class: "mt-4 space-y-3"
};
const _hoisted_5 = {
  class: "grid grid-cols-1 gap-2 sm:grid-cols-[1fr_auto_auto]"
};
const _hoisted_6 = {
  class: "min-h-0 flex-1 overflow-y-auto p-3"
};
const _hoisted_7 = {
  key: 0,
  class: "flex h-40 items-center justify-center text-sm text-slate-500"
};
const _hoisted_8 = {
  key: 1,
  class: "flex h-40 items-center justify-center rounded-lg border border-dashed border-slate-300 bg-slate-50 text-sm text-slate-500"
};
const _hoisted_9 = {
  key: 2,
  class: "space-y-2"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "flex items-start justify-between gap-2"
};
const _hoisted_12 = {
  class: "min-w-0"
};
const _hoisted_13 = {
  class: "flex items-center gap-2"
};
const _hoisted_14 = {
  class: "text-xs font-medium text-slate-500"
};
const _hoisted_15 = ["title"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["title"];
import { onMounted, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { DocumentDuplicateIcon, PlusIcon } from '@heroicons/vue/24/outline';
import { getEnterpriseInvoicePlanPage } from '@/api/invoice';
import { statusLabel, statusTone } from '../utils';
export default {
  __name: 'InvoicePlanPanel',
  props: {
    modelValue: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['update:modelValue', 'create', 'copy'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const loading = ref(false);
    const plans = ref([]);
    const filters = reactive({
      keyword: '',
      planMonth: ''
    });
    let loadRequestSeq = 0;
    function statusClass(status) {
      const tone = statusTone(status);
      const toneClasses = {
        neutral: 'status-badge is-neutral',
        primary: 'status-badge is-info',
        amber: 'status-badge is-warning',
        emerald: 'status-badge is-success',
        red: 'status-badge is-danger'
      };
      return toneClasses[tone] || toneClasses.neutral;
    }
    function isSelected(plan) {
      return String(plan?.id) === String(props.modelValue);
    }
    function selectPlan(plan) {
      emit('update:modelValue', plan?.id || null);
    }
    function resetFilters() {
      filters.keyword = '';
      filters.planMonth = '';
      loadPlans();
    }
    async function loadPlans() {
      const requestSeq = ++loadRequestSeq;
      loading.value = true;
      try {
        const result = await getEnterpriseInvoicePlanPage({
          keyword: filters.keyword?.trim(),
          planMonth: filters.planMonth || undefined,
          page: 1,
          size: 50
        });
        if (requestSeq !== loadRequestSeq) return;
        plans.value = result?.records || result?.list || [];
        const hasCurrentPlan = plans.value.some(plan => String(plan.id) === String(props.modelValue));
        if (!hasCurrentPlan) {
          emit('update:modelValue', plans.value[0]?.id || null);
        }
      } catch (error) {
        if (requestSeq !== loadRequestSeq) return;
        console.error('Failed to load enterprise invoice plans', error);
        ElMessage.error('加载企营增方案列表失败');
      } finally {
        if (requestSeq === loadRequestSeq) {
          loading.value = false;
        }
      }
    }
    onMounted(() => {
      loadPlans();
    });
    __expose({
      loadPlans
    });
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("aside", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "min-w-0"
      }, [_createElementVNode("h2", {
        class: "text-base font-semibold text-slate-900"
      }, "月度方案"), _createElementVNode("p", {
        class: "mt-1 text-xs leading-5 text-slate-500"
      }, "按月份维护客户名单和开票链路")], -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-primary inline-flex shrink-0 items-center gap-1.5",
        onClick: _cache[0] || (_cache[0] = $event => emit('create'))
      }, [_createVNode(_unref(PlusIcon), {
        class: "h-4 w-4"
      }), _cache[3] || (_cache[3] = _createTextVNode(" 新建 ", -1))])), [[_directive_permission, 'enterprise-invoice:plan:create']])]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.keyword = $event),
        type: "search",
        class: "form-search-input form-control-sm w-full",
        placeholder: "搜索方案名称",
        onKeyup: _withKeys(loadPlans, ["enter"])
      }, null, 544), [[_vModelText, filters.keyword]]), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.planMonth = $event),
        type: "month",
        class: "form-input form-control-sm w-full"
      }, null, 512), [[_vModelText, filters.planMonth]]), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        onClick: resetFilters
      }, "重置"), _createElementVNode("button", {
        type: "button",
        class: "btn-primary",
        onClick: loadPlans
      }, "搜索")])])]), _createElementVNode("div", _hoisted_6, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 加载中... ")) : plans.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 暂无方案 ")) : (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plans.value, plan => {
        return _openBlock(), _createElementBlock("button", {
          key: plan.id,
          type: "button",
          class: _normalizeClass(['w-full rounded-lg border p-3 text-left transition-colors', isSelected(plan) ? 'border-primary-300 bg-primary-50' : 'border-slate-200 bg-white hover:border-primary-200 hover:bg-slate-50']),
          onClick: $event => selectPlan(plan)
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(plan.planMonth || '-'), 1), _createElementVNode("span", {
          class: _normalizeClass(['status-badge', statusClass(plan.status)])
        }, _toDisplayString(_unref(statusLabel)(plan.status)), 3)]), _createElementVNode("h3", {
          class: "mt-2 truncate text-sm font-semibold text-slate-900",
          title: plan.planName
        }, _toDisplayString(plan.planName || '-'), 9, _hoisted_15)]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "table-action-button is-purple shrink-0",
          title: "复制方案",
          "aria-label": "复制方案",
          onClick: _withModifiers($event => emit('copy', plan), ["stop"])
        }, [_createVNode(_unref(DocumentDuplicateIcon), {
          class: "h-4 w-4"
        })], 8, _hoisted_16)), [[_directive_permission, 'enterprise-invoice:plan:copy']])]), _createElementVNode("p", {
          class: "mt-2 line-clamp-2 min-h-[32px] text-xs leading-4 text-slate-500",
          title: plan.lastChangeReason
        }, _toDisplayString(plan.lastChangeReason || '最后变更原因：-'), 9, _hoisted_17)], 10, _hoisted_10);
      }), 128))]))])]);
    };
  }
};